/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {Injectable, Optional} from '@angular/core';
import {FcAgEditorConfig} from './types';
import Locals from './Locals';

/**
 * Editor service config.
 */
@Injectable({
    providedIn: 'root'
})
export class FcAgEditorServiceConfig {
    /**
     * Locals.
     */
    public locals = {};
}

/**
 * Editor Service.
 */
@Injectable({
    providedIn: 'root'
})
export class FcAgEditorService {
    /**
     * Config.
     */
    config: FcAgEditorServiceConfig;

    /**
     * Default constructor.
     * 
     * @param config FcAgEditorServiceConfig.
     */
    constructor(@Optional() config?: FcAgEditorServiceConfig) {
        this.config = config ?? {locals: {}};
    }

    /**
     * Getter for locals.
     * 
     * @returns Locals.
     */
    get locals(): Locals {
        return new Locals(this.config.locals);
    }
}

export const provideMyServiceOptions = (config?: FcAgEditorConfig): FcAgEditorServiceConfig => {
    return {
        locals: config ? config.locals ?? {} : {}
    };
};
